import { FETCH_COMMENT_STATUSES } from 'actions';

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_COMMENT_STATUSES:
            return action.payload;
        default:
            return state;
    }
};